import { useEffect, useState } from "react";
import Bowser from "bowser";

/**
 * Helper hook that allows us to check the browser agent of a specific browser
 */
export function useBrowserAgent() {
  const [browserAgent, setBrowserAgent] = useState<Bowser.Parser.Parser | null>(
    null
  );

  // This library is only useful when running inside a browser,
  // so we fill the state inside a useEffect
  useEffect(() => {
    const browser = Bowser.getParser(window.navigator.userAgent);

    setBrowserAgent(browser);
  }, []);

  return {
    browserAgent,
    isWebKit: browserAgent
      ? browserAgent.getEngineName().toLowerCase() === "webkit"
      : false,
  };
}

function isWebKit() {
  const browser = Bowser.getParser(window.navigator.userAgent);

  return browser ? browser.getEngineName().toLowerCase() === "webkit" : false;
}

export const BrowserAgent = {
  isWebKit,
};
